import type {FeedbackType} from "./types";

export const FEEDBACK_TYPE_OPTIONS: Array<{value: FeedbackType; label: string}> = [
    {value: 'bug', label: 'Bug'},
    {value: 'idea', label: 'Idea'},
    {value: 'missing_data', label: 'Missing data'},
    {value: 'other', label: 'Something else'}
];

export const FEEDBACK_MESSAGE_MAX_LENGTH = 4000;
export const FEEDBACK_SUBJECT_MAX_LENGTH = 255;
export const FEEDBACK_EMAIL_MAX_LENGTH = 255;
export const FEEDBACK_RAW_DATA_MAX_BYTES = 41_943_040;
export const FEEDBACK_RAW_DATA_ACCEPT = '.csv,.zip,text/csv,application/zip,application/x-zip-compressed';

export const FEEDBACK_DIALOG_TITLE = 'Share feedback';
export const FEEDBACK_DIALOG_DESCRIPTION = 'Tell me what works, what is missing, or what is broken.';
export const FEEDBACK_SUBMIT_LABEL = 'Send feedback';
export const FEEDBACK_SENDING_LABEL = 'Sending...';
export const FEEDBACK_SUCCESS_MESSAGE = 'Feedback sent.';
export const FEEDBACK_RAW_DATA_OPT_IN_LABEL = 'Attach my original CSV or ZIP file';
export const FEEDBACK_RAW_DATA_OPT_IN_HELP = 'Uploading your eBird My Data ZIP file can help me recreate and fix problems related to your speicfic eBird data. ';
